import React from 'react';
import { Button, Grid, TextField } from '@material-ui/core';
import styled from 'styled-components';
import { FieldErrors, UseFormMethods } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SignInWithSsoFormValues } from '../common/interfaces';
import { SpinnerComponent } from '../common/spinnerComponent';

interface SignInWithSsoFormProps {
    submitSignInWithSso: (data: SignInWithSsoFormValues) => void;
    fieldsErrors: FieldErrors;
    handleSubmit: UseFormMethods['handleSubmit'];
    register: UseFormMethods['register'];
    loading: boolean;
}

export const SignInWithSsoForm = ({ 
    submitSignInWithSso,  
    fieldsErrors, 
    handleSubmit, 
    register,
    loading
}: SignInWithSsoFormProps) => {
    const { t } = useTranslation();

    return (
        <Grid item xs={12}>
            <form onSubmit={handleSubmit(submitSignInWithSso)}>
                <Grid container item xs={12}>
                    <TextField
                        id='domain'
                        name='domain'
                        type='string'
                        label={t('domain')}
                        helperText={fieldsErrors.domain ? fieldsErrors.domain.message : null}
                        size='small'
                        variant='outlined'
                        autoFocus
                        fullWidth
                        inputRef={register({
                            required: {
                                value: true,
                                message: t('pleaseInputYourCompanysDomain')
                            }
                        })}
                        error={!!fieldsErrors.domain}
                    />
                </Grid>
                <Grid container item direction='row' alignItems='center' xs={12}>
                    <Grid container item xs={12}>
                        <SubmitSignInWithSsoButton 
                            color='primary' 
                            fullWidth 
                            type='submit' 
                            variant='contained'
                            disableElevation
                        >
                            {t('next')}
                            {loading && <SpinnerComponent />}
                        </SubmitSignInWithSsoButton>
                    </Grid>
                </Grid>
            </form>
        </Grid>
    );
};

const SubmitSignInWithSsoButton = styled(Button)`
    background-color: #0083C6;
    margin-top: 30px;
`;

